import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { setCards, setCollections, restoreFlipStateFromPersistence } from "./thunks";
import FlipMatchProgress from "../../components/FlipMatchProgress/FlipMatchProgress";
import FlipMatchState from "../FlipMatchState/FlipMatchState";
import { CARDS, FLIP_MATCH_STATE_TYPE } from "./constants";
import FlipMatchCardList from "../FlipMatchCardList/FlipMatchCardList";
import TypewriterText from "../../components/TypewriterText/TypewriterText";
import { loadPersistedFlipState } from "../../utils/flipStatePersistence";

class FlipMatch extends React.Component {

    componentDidMount() {
        const { flip, setCardsAction, setCollectionsAction, restoreAction } = this.props;
        setCollectionsAction(CARDS);
        const persisted = loadPersistedFlipState();
        if (persisted && CARDS[persisted.collectionName]) {
            restoreAction(persisted.collectionName, persisted.flippedCardNames);
        } else {
            setCardsAction(flip.collectionDefault);
        }
    }

    render = () => {
        const { flip } = this.props;
        const FlipMatchSuccess = flip.completeScreen.component;
        return (
            <div className={`flip${flip.complete ? " flip--complete" : ""}`}>
                {flip.flipped.length ?
                    <FlipMatchProgress flip={flip} className="flip-progress" itemClassName="flip-progress-item d-flex flex-column"/>
                :
                    <div className="flip-progress">
                        <TypewriterText key={`${flip.collection.name}-${flip.dealTrigger || 0}`} text={flip.collection.description || ""} />
                    </div>
                }
                {flip.collection.cards.length ?
                    <FlipMatchCardList flip={flip} className="flip-cards" itemClassName="column p-1"/>
                :
                    <div className="flip-cards">
                        <h2>{this.props.t("no_cards_found")}</h2>
                    </div>
                }
                {flip.complete &&
                    <FlipMatchSuccess {...flip.completeScreen.props} flip={flip}/>
                }
            </div>
        )
    }
}

FlipMatch.propTypes = {
    setCardsAction: PropTypes.func.isRequired,
    setCollectionsAction: PropTypes.func.isRequired,
    restoreAction: PropTypes.func.isRequired,
    flip: FLIP_MATCH_STATE_TYPE,
    t: PropTypes.func.isRequired,
};

FlipMatch.defaultProps = {
    flip: {}
};

const mapDispatchToProps = (dispatch) => ({
    setCardsAction: (collection) => dispatch(setCards(collection)),
    setCollectionsAction: (collections) => dispatch(setCollections(collections)),
    restoreAction: (collectionName, flippedCardNames) =>
        dispatch(restoreFlipStateFromPersistence(collectionName, flippedCardNames)),
});

export default FlipMatchState(connect(
    null,
    mapDispatchToProps
)(withTranslation()(FlipMatch)));